export const newCron = () => ({
  type: "cron",
  minute: "0",
  hour: "9",
  day_of_week: "*",
  day_of_month: "*",
  month_of_year: "*",
  timezone: "America/New_York",
});
export const newInterval = () => ({
  type: "interval",
  every: 1,
  period: "hours",
});
export const weekdays = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
export function cronPreset(schedule) {
  if (
    !/^\d+$/.test(schedule.minute) ||
    !/^\d+$/.test(schedule.hour) ||
    schedule.month_of_year !== "*"
  )
    return "custom";
  if (schedule.day_of_month === "*")
    return schedule.day_of_week === "*" ? "daily" : "weekly";
  if (/^\d+$/.test(schedule.day_of_month) && schedule.day_of_week === "*")
    return "monthly";
  return "custom";
}
// Read ranges/steps/names for the selectors, but keep original expressions in
// form state until the user actually changes a field.
export function cronValues(expression, min, max, names = []) {
  if (expression === "*") return [];
  const values = new Set();
  const number = (value) => {
    const named = names.findIndex(
      (name) => name.slice(0, 3).toLowerCase() === value.toLowerCase()
    );
    return named >= 0 ? named + min : Number(value);
  };
  for (const part of expression.split(",")) {
    const [range, stepText] = part.split("/");
    const step = stepText === undefined ? 1 : Number(stepText);
    const pieces = range.split("-");
    const start = range === "*" ? min : number(pieces[0]);
    const end =
      range === "*"
        ? max
        : pieces.length > 1
          ? number(pieces[1])
          : stepText
            ? max
            : start;
    if (
      !Number.isInteger(start) ||
      !Number.isInteger(end) ||
      !Number.isInteger(step) ||
      step < 1 ||
      start < min ||
      end > max ||
      end < start
    )
      return [];
    for (let value = start; value <= end; value += step) values.add(value);
  }
  return [...values].sort((a, b) => a - b);
}
export function errorMessage(error) {
  const data = error?.response?.data;
  if (!data) return error?.message || "Something went wrong. Please try again.";
  const flatten = (value) =>
    typeof value === "string"
      ? value
      : Array.isArray(value)
        ? value.map(flatten).join(" ")
        : Object.entries(value)
            .map(([key, text]) => `${key}: ${flatten(text)}`)
            .join(" ");
  return flatten(data);
}
export function changedFields(original, draft) {
  return Object.fromEntries(
    Object.entries(draft).filter(
      ([key, value]) =>
        JSON.stringify(original[key] ?? (key === "description" ? "" : null)) !==
        JSON.stringify(value)
    )
  );
}
export function displayTime(value, zone) {
  if (!value) return "—";
  return new Intl.DateTimeFormat("en-US", {
    dateStyle: "medium",
    timeStyle: "short",
    ...(zone ? { timeZone: zone } : {}),
  }).format(new Date(value));
}
